import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getAccountUsersSaga(action: types.GetAccountUsersActionType) {
  try {
    const response = yield call(
      services.getAccountUsersService,
      action.payload
    );
    yield put({ type: actions.GET_ACCOUNT_USERS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ACCOUNT_USERS_ERROR, response: error });
  }
}

export function* addAccountUserSaga(action: types.AddAccountUserActionType) {
  try {
    const addResponse = yield call(
      services.addAccountUserService,
      action.payload
    );
    const getResponse = yield call(services.getAccountUsersService);
    if (addResponse.data) {
      yield put({
        type: actions.ADD_ACCOUNT_USER_SUCCESS,
        response: addResponse,
      });
      yield put({
        type: actions.GET_ACCOUNT_USERS_SUCCESS,
        response: getResponse,
      });
      toastr.success("User Added to Account", `Welcome!`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({ type: actions.ADD_ACCOUNT_USER_ERROR, response: error });
    toastr.error("User Not Added to Account", `${error.error.message}`);
  }
}

export function* deleteAccountUserSaga(
  action: types.DeleteAccountUserActionType
) {
  try {
    const deleteResponse = yield call(
      services.deleteAccountUserService,
      action.payload
    );
    const getResponse = yield call(services.getAccountUsersService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_ACCOUNT_USER_SUCCESS,
        response: deleteResponse,
      });
      yield put({
        type: actions.GET_ACCOUNT_USERS_SUCCESS,
        response: getResponse,
      });
      toastr.success("User Removed from Account", `Sad to see them go!`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_ACCOUNT_USER_ERROR, response: error });
    toastr.error("User Not Added to Account", `${error.error.message}`);
  }
}
